export default __webpack_public_path__ + "static/media/bg.94466d49.jpg";